import React, { useContext, useEffect, useState } from 'react'
import Layout from './Layout'
import Leads from '../../Pages/Leads'
import Dashboard from '../../Pages/Dashboard'
import Scoreboard from '../../Pages/Scoreboard'
import TopSection from '../Common/TopSection'
import { LeadsContext } from '../Context/LeadsContext'
import { getImages } from '../Const'
import CalenderTabContent from '../Calendar/CalenderTabContent'
import WeekCalender from '../Calendar/WeekCalender';
import { UserContext } from '../Context/UserContext'


const CommonLayout = ({ children }) => {
    const { getLeads, isInitialLoad, filteredLeads, filteredArchivedLeadData, leadData, getAnnouncements } = useContext(LeadsContext);
    const {logActivity} = useContext(UserContext);

    const [tabs, setTabs] = useState(false);

    const [dashTabActive, setDashTabActive] = useState(() => {
        const storedValue = localStorage.getItem('dashTabActive');
        return storedValue && storedValue != "undefined" ? JSON.parse(storedValue) : 'leadsTab'
    });
    const [leadType, setLeadType] = useState(() => {
        const storedValue = localStorage.getItem('leadType');
        return storedValue && storedValue != "undefined" ? JSON.parse(storedValue) : "EQR"
    });
    const [leadLocation, setLeadLocation] = useState(() => {
        const storedValue = localStorage.getItem('leadLocation');
        return storedValue && storedValue != "undefined" ? JSON.parse(storedValue) : 'POMPANO BEACH'
    });


    const handleDashTab = (tabsName, lead_type, location = '') => {
        console.log(tabsName,lead_type,location);
        setDashTabActive(tabsName);
        setLeadType(lead_type);
        setLeadLocation(location);

        localStorage.setItem('dashTabActive', JSON.stringify(tabsName));
        localStorage.setItem('leadType', JSON.stringify(lead_type));
        localStorage.setItem('leadLocation', JSON.stringify(location));
    };

    const handleBackBtn = () => {
        //setDashTabActive('')
    }

    // Mobile View
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const checkScreenWidth = () => {
            const currentWidth = window.innerWidth;
            setScreenWidth(currentWidth);

            if (currentWidth < 991) {
                handleDashTab('streetLeads');
            }
        };

        // Check screen width on component mount
        checkScreenWidth();

        // Add event listener for resize
        window.addEventListener('resize', checkScreenWidth);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', checkScreenWidth);
        };
    }, []);

        
    const [announcements,setAnnouncements] = useState([]);

    const fetchAnnouncements = async () => {
        const data = await getAnnouncements();

        var today = new Date();
    
        setAnnouncements(data.filter((v) => new Date(v.expiration) > today));
    }
        
    useEffect(() => {
        if(!isInitialLoad) {
            getLeads(true,true);
            fetchAnnouncements();
        }
    },[]);

    const [unreadCounts,setUnreadCounts] = useState({
        'EQR_Pompano':0,
        'EQR_Boynton':0,
        'KBB_Pompano':0,
        'KBB_Boynton':0,
        'Mall':0
    });

    useEffect(() => {
        var unread_counts = {
            'EQR_Pompano':0,
            'EQR_Boynton':0,
            'KBB_Pompano':0,
            'KBB_Boynton':0,
            'Mall':0
        };

        leadData.map((v,i) => {
            if(!v.new_lead) return;

            if(v.lead_type == "EQR") {
                if(v.location == "POMPANO BEACH") unread_counts['EQR_Pompano']++;
                else unread_counts['EQR_Boynton']++;
            } else if(v.lead_type == "KBB") {
                if(v.location == "POMPANO BEACH") unread_counts['KBB_Pompano']++;
                else unread_counts['KBB_Boynton']++;
            } else if(v.lead_type == "KBB-K") unread_counts['Mall']++;
        });

        console.log("setting unread counts",unread_counts);
        setUnreadCounts(unread_counts);
        //if(leadData && leadData.length > 0) logActivity();

    },[leadData]);

    const [tabClick,setTabClick] = useState(0);

    const updateTabClick = () => {
        setTabClick((prev) => prev + 1);
    }

    return (
        <>
            <Layout tabClick={tabClick}>
                <div className='main-block'>
                    <div className='custom-tabs'>
                        <nav className='mn-tabs'>
                            <div className='container-fluid'>
                                <div className="nav nav-tabs">
                                    <button
                                        className={`nav-link position-relative ${(dashTabActive === "leadsTab" && leadType === "EQR" && leadLocation === "POMPANO BEACH") ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => {handleDashTab("leadsTab", "EQR", "POMPANO BEACH"); setUnreadCounts({...unreadCounts,'EQR_Pompano':0}); updateTabClick();}}
                                    >
                                        <div className='mob_tab_icon d-lg-none mb-3'>
                                        <img src={getImages('street_leads_icon.svg')} />
                                        </div>
                                        EQR - POMPANO
                                        {unreadCounts.EQR_Pompano > 0 && <div className='custom-badge'>{unreadCounts.EQR_Pompano}</div>}
                                    </button>
                                    <button
                                        className={`nav-link position-relative ${(dashTabActive === "leadsTab" && leadType === "EQR" && leadLocation === "BOYNTON BEACH") ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => {handleDashTab("leadsTab", "EQR", "BOYNTON BEACH"); setUnreadCounts({...unreadCounts,'EQR_Boynton':0}); updateTabClick();}}
                                    >
                                        <div className='mob_tab_icon d-lg-none mb-3'>
                                        <img src={getImages('street_leads_icon.svg')} />
                                        </div>
                                        EQR - BOYNTON
                                        {unreadCounts.EQR_Boynton > 0 && <div className='custom-badge'>{unreadCounts.EQR_Boynton}</div>}
                                    </button>
                                    <button
                                        className={`nav-link position-relative ${(dashTabActive === "leadsTab" && leadType === "KBB" && leadLocation === "POMPANO BEACH") ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => {handleDashTab("leadsTab", "KBB", "POMPANO BEACH"); setUnreadCounts({...unreadCounts,'KBB_Pompano':0}); updateTabClick();}}
                                    >
                                        <div className='mob_tab_icon d-lg-none mb-3'>
                                        <img src={getImages('street_leads_icon.svg')} />
                                        </div>
                                        KBB - POMPANO
                                        {unreadCounts.KBB_Pompano > 0 && <div className='custom-badge'>{unreadCounts.KBB_Pompano}</div>}
                                    </button>
                                    <button
                                        className={`nav-link position-relative ${(dashTabActive === "leadsTab" && leadType === "KBB" && leadLocation === "BOYNTON BEACH") ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => {handleDashTab("leadsTab", "KBB", "BOYNTON BEACH"); setUnreadCounts({...unreadCounts,'KBB_Boynton':0}); updateTabClick();}}
                                    >
                                        <div className='mob_tab_icon d-lg-none mb-3'>
                                        <img src={getImages('street_leads_icon.svg')} />
                                        </div>
                                        KBB - BOYNTON
                                        {unreadCounts.KBB_Boynton > 0 && <div className='custom-badge'>{unreadCounts.KBB_Boynton}</div>}
                                    </button>
                                    <button
                                        className={`nav-link position-relative ${(dashTabActive === "leadsTab" && leadType == "KBB-K") ? 'active' : ''}`}
                                        type="button"
                                        onClick={() => {handleDashTab('leadsTab', "KBB-K", "POMPANO BEACH"); setUnreadCounts({...unreadCounts,'Mall':0}); updateTabClick();}}
                                    >
                                        <div className='mob_tab_icon d-lg-none mb-3'>
                                        <img src={getImages('street_leads_icon.svg')} />
                                        </div>
                                        MALL
                                        {unreadCounts.Mall > 0 && <div className='custom-badge'>{unreadCounts.Mall}</div>}
                                    </button>
                                    <button className={`nav-link position-relative ms-auto ${(dashTabActive == "calendar") ? "active" : ""} `} type="button" onClick={() => {handleDashTab('calendar'); updateTabClick();}}>
                                        <div className='mob_tab_icon d-lg-none mb-3'><img src={getImages('scoreboard_icon.svg')} /></div>Calendar
                                    </button>
                                    {/* <button className={`nav-link position-relative`} id="nav-appointments-tab" data-bs-toggle="tab" data-bs-target="#nav-appointments" type="button" role="tab" aria-controls="nav-appointments" aria-selected="false" onClick={()=>handleDashTab('dealerLeads')}><div className='mob_tab_icon d-lg-none mb-3'><img src={getImages('dealer_leads_icon.svg')}/></div>Team Scoreboard</button> */}
                                    <button className={`nav-link position-relative me-0 ${(dashTabActive == "leadsTab" && leadType == "archived") ? "active" : ""}`} type="button" onClick={() => {handleDashTab('leadsTab', 'archived'); updateTabClick();}}>
                                        <div className='mob_tab_icon d-lg-none mb-3'><img src={getImages('reporting_icon.svg')} /></div>ARCHIVED
                                    </button>
                                </div>
                            </div>
                        </nav>
                        <div className='container-fluid'>
                            <div className="tab-content main-tab-content">
                                {/* {dashTabActive == "leadsTab" && 
                                    <Leads 
                                        handleBackBtn={handleBackBtn} 
                                        filteredLeads={leadType == 'archived' ? filteredArchivedLeadData : filteredLeads.filter((lead) => lead.lead_type == leadType)}
                                        handleDashTab={handleDashTab}
                                        allLeadData={leadData}
                                    />
                                } */}
                                {dashTabActive === "leadsTab" && (
                                    <Leads
                                        handleBackBtn={handleBackBtn}
                                        filteredLeads={
                                            leadType === 'archived' || leadType === 'mall'
                                                ? filteredArchivedLeadData
                                                : filteredLeads.filter(lead =>
                                                    lead.lead_type === leadType &&
                                                    lead.location === leadLocation
                                                )
                                        }
                                        handleDashTab={handleDashTab}
                                        allLeadData={leadData}
                                        dashTabActive={dashTabActive}
                                        leadType={leadType}
                                        leadLocation={leadLocation}
                                        tabClick={tabClick}
                                    />
                                )}
                                {dashTabActive == "calendar" &&
                                    <CalenderTabContent handleBackBtn={handleBackBtn} leadData={leadData} announcements={announcements}/>
                                }
                                {dashTabActive == "dashboard" &&
                                    <Dashboard handleBackBtn={handleBackBtn} />
                                }
                                {dashTabActive == "scoreboard" &&
                                    <Scoreboard handleBackBtn={handleBackBtn} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default CommonLayout
